export const REQUEST_BONUS_GIFTS = 'zola/registryBenefits/REQUEST_BONUS_GIFTS';
export const RECEIVE_BONUS_GIFTS = 'zola/registryBenefits/RECEIVE_BONUS_GIFTS';
